module.exports = __webpack_public_path__ + "static/media/wizualizacja-19.6c1e8de7.png";